import React, { useEffect, useState } from "react";
import "./network-content.scss";

import CollageRow from "../../atoms/collage-row/collage-row";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CollageMobile from "../collage-mobile/collage-mobile";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const settings = {
  dots: true,
  infinite: false,
  arrows: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
};

interface InfoInterface {
  title: string;
  information: string;
  url?: string;
  tituloBoton?: string;
  redirect: string;
  costless_chip: boolean;
}

const NetworkContentSection = (props: ReferenciaContenido) => {
  const networkContentData = props;

  const [collageInfo, setCollageInfo] = useState(new Array<InfoInterface>());

  const parseData = () => {
    const auxArray = new Array<InfoInterface>();
    networkContentData?.referenciaPlantillaContenido.map((elem) => {
      auxArray.push({
        title: elem?.tituloBanner,
        information: JSON.parse(elem?.descripcion?.raw)?.content[0]?.content[0]
          ?.value,
        url: elem?.imagenPrincipal
          ? elem.imagenPrincipal[0]?.gatsbyImageData
          : null,
        redirect: elem?.redireccionBoton,
        costless_chip: elem?.tituloDescripcion === "Sin cobro" ? true : false,
        tituloBoton: elem?.tituloBoton,
      });
    });
    setCollageInfo(auxArray);
  };

  useEffect(() => {
    parseData();
  }, []);

  const collageInfoEnterprises = [
    {
      title: networkContentData?.referenciaPlantillaContenido[0]?.tituloBanner,
      information: JSON.parse(
        networkContentData?.referenciaPlantillaContenido[0]?.descripcion?.raw
      )?.content[0]?.content[0]?.value,
      url:
        networkContentData?.referenciaPlantillaContenido[0]?.imagenPrincipal[0]
          ?.gatsbyImageData,
      redirect:
        networkContentData?.referenciaPlantillaContenido[0]?.redireccionBoton,
      costless_chip:
        networkContentData?.referenciaPlantillaContenido[0]
          ?.tituloDescripcion === "Sin cobro"
          ? true
          : false,
    },
    {
      title: networkContentData?.referenciaPlantillaContenido[1]?.tituloBanner,
      information: JSON.parse(
        networkContentData?.referenciaPlantillaContenido[1]?.descripcion?.raw
      )?.content[0]?.content[0]?.value,
      url:
        networkContentData?.referenciaPlantillaContenido[1]?.imagenPrincipal[0]
          ?.gatsbyImageData,
      redirect:
        networkContentData?.referenciaPlantillaContenido[1]?.redireccionBoton,
      costless_chip:
        networkContentData?.referenciaPlantillaContenido[1]
          ?.tituloDescripcion === "Sin cobro"
          ? true
          : false,
    },
    {
      title: networkContentData?.referenciaPlantillaContenido[2]?.tituloBanner,
      information: JSON.parse(
        networkContentData?.referenciaPlantillaContenido[2]?.descripcion?.raw
      )?.content[0]?.content[0]?.value,
      url:
        networkContentData?.referenciaPlantillaContenido[2]?.imagenPrincipal[0]
          ?.gatsbyImageData,
      redirect:
        networkContentData?.referenciaPlantillaContenido[2]?.redireccionBoton,
      costless_chip:
        networkContentData?.referenciaPlantillaContenido[2]
          ?.tituloDescripcion === "Sin cobro"
          ? true
          : false,
    },
    {
      title: networkContentData?.referenciaPlantillaContenido[3]?.tituloBanner,
      information: JSON.parse(
        networkContentData?.referenciaPlantillaContenido[3]?.descripcion?.raw
      )?.content[0]?.content[0]?.value,
      url:
        networkContentData?.referenciaPlantillaContenido[3]?.imagenPrincipal[0]
          ?.gatsbyImageData,
      redirect:
        networkContentData?.referenciaPlantillaContenido[3]?.redireccionBoton,
      costless_chip:
        networkContentData?.referenciaPlantillaContenido[3]
          ?.tituloDescripcion === "Sin cobro"
          ? true
          : false,
    },
    {
      title: networkContentData?.referenciaPlantillaContenido[4]?.tituloBanner,
      information: JSON.parse(
        networkContentData?.referenciaPlantillaContenido[4]?.descripcion?.raw
      )?.content[0]?.content[0]?.value,
      url:
        networkContentData?.referenciaPlantillaContenido[4]?.imagenPrincipal[0]
          ?.gatsbyImageData,
      redirect:
        networkContentData?.referenciaPlantillaContenido[4]?.redireccionBoton,
      costless_chip:
        networkContentData?.referenciaPlantillaContenido[4]
          ?.tituloDescripcion === "Sin cobro"
          ? true
          : false,
    },
    {
      title: networkContentData?.referenciaPlantillaContenido[5]?.tituloBanner,
      tituloBoton:
        networkContentData?.referenciaPlantillaContenido[5]?.tituloBoton,
      redirect:
        networkContentData?.referenciaPlantillaContenido[5]?.redireccionBoton,
    },
  ];

  return (
    <div className="m-content-network">
      <div className="m-content-network__title">
        <h2>{networkContentData?.tituloGeneral}</h2>
      </div>

      {networkContentData?.titulo?.split(">")[0] === "Empresas red de amor " ? (
        <CollageMobile cardsArray={collageInfoEnterprises} />
      ) : (
        <CollageMobile cardsArray={collageInfo} />
      )}
      {networkContentData?.titulo?.split(">")[0] === "Empresas red de amor " ? (
        <div className="m-content-network__slider hide-on-mobile">
          <Slider {...settings}>
            <div className="slider">
              <div className="m-content-network__center">
                <div className="m-content-network__collage">
                  <CollageRow
                    card1={collageInfoEnterprises[0]}
                    card2={collageInfoEnterprises[1]}
                    card3={collageInfoEnterprises[2]}
                    hasButton={false}
                  ></CollageRow>
                  <CollageRow
                    card1={collageInfoEnterprises[3]}
                    card2={collageInfoEnterprises[4]}
                    card3={collageInfoEnterprises[5]}
                    hasButton={true}
                  ></CollageRow>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      ) : (
        <div className="m-content-network__slider hide-on-mobile">
          <Slider {...settings}>
            <div className="slider">
              <div className="m-content-network__center">
                <div className="m-content-network__collage">
                  <CollageRow
                    card1={collageInfo[0]}
                    card2={collageInfo[1]}
                    card3={collageInfo[2]}
                    hasButton={false}
                  ></CollageRow>
                  <CollageRow
                    card1={collageInfo[3]}
                    card2={collageInfo[4]}
                    card3={collageInfo[5]}
                    hasButton={true}
                  ></CollageRow>
                </div>
              </div>
            </div>
            {collageInfo.length === 12 ? (
              <div className="slider">
                <div className="m-content-network__center">
                  <div className="m-content-network__collage">
                    <CollageRow
                      card1={collageInfo[6]}
                      card2={collageInfo[7]}
                      card3={collageInfo[8]}
                      hasButton={false}
                    ></CollageRow>
                    <CollageRow
                      card1={collageInfo[9]}
                      card2={collageInfo[10]}
                      card3={collageInfo[11]}
                      hasButton={false}
                    ></CollageRow>
                  </div>
                </div>
              </div>
            ) : null}
          </Slider>
        </div>
      )}
    </div>
  );
};

export default NetworkContentSection;
